import React, { Component, Suspense, useEffect } from 'react'
import { HashRouter, Route, Routes, useLocation } from 'react-router-dom'
import './scss/style.scss'
import PrivateRoute from './views/PrivateRoute'
import { useTranslation } from 'react-i18next'
import { ToastContainer } from 'react-toastify'
import './components/style.scss'
import DsAppCallReport from './views/pages/callReport/dsAppCallReport'
import DSApplicationContact from './views/pages/contacts/widgets/contactWidgets/dsAppContact'
import ExternalPurchaseWizard from './views/pages/externalPurchaseWizard'
import { initDB } from 'react-indexed-db-hook'
import { DBConfig, createDownloadLink } from './components/helper'
import LoginPage from './views/pages/auth/loginPage'
import RegisterPage from './views/pages/auth/registerPage'
import ShortLink from './views/pages/shortLink'








// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
// Pages
const Login = React.lazy(() => import('./views/pages/auth/login'))
const Register = React.lazy(() => import('./views/pages/auth/register'))
// const Transaction=React.lazy(() => import('./views/pages/listtransaction'))
const PasswordRecovery = React.lazy(() => import('./views/pages/auth/PasswordRecovery'))



initDB(DBConfig);


const App = () => {

  const { i18n } = useTranslation()
  document.body.dir = i18n.dir()
  document.getElementsByTagName('html')[0].setAttribute("dir", i18n.dir())
  document.documentElement.setAttribute('lang', i18n.language)
  document.body.classList.add(i18n.language)

  // var script = document.createElement('script');
  // script.type = 'text/javascript';
  // script.src = "gtmScript.js";
  // document.head.appendChild(script);

  useEffect(() => {
    const currentUrl = window.location.pathname + window.location.search;

    if (!window.location.hash && currentUrl !== '/') {
      debugger
      if (!currentUrl.includes("Rahnama-Gooya-V3.1.pdf") && !currentUrl.includes("Rahnama-monshi-(V2.0).pdf")) {
        if (createDownloadLink(currentUrl)) {
          window.location.replace(`#/shortLink${currentUrl}`);

        } else {
          window.location = "/#/dashboard"
        }
      }

    }
  }, []);


  return (
    <>
      <HashRouter>
        <Routes>
          <Route exact path="/login" name="Login Page" element={<LoginPage />} />
          <Route exact path="/login/:prop" name="Login Page" element={<LoginPage />} />

          {/* <Route exact path="transaction" name="Transaction Page" element={<Transaction />} /> */}
          <Route exact path="/register" name="Register Page" element={<RegisterPage />} />
          <Route exact path="/dsAppCallReport" name="Register Page" element={<DsAppCallReport />} />
          <Route exact path="/dsAppContact" name="ds app contact" element={<DSApplicationContact />} />
          <Route exact path="/shortLink/:shortLinkParam" name="shortLink" element={<ShortLink />} />


          <Route exact path="/landingPurchase/:step/:productType/:productId/:contractTypeId"
            name="landingPurchase" element={<ExternalPurchaseWizard />} />
          <Route exact path="/landingPurchase/:step"
            name="landingPurchase" element={<ExternalPurchaseWizard />} />

          <Route exact path="/landingPurchase/:step/:purchaseType/:invoiceId"
            name="landingPurchase" element={<ExternalPurchaseWizard />} />

          <Route exact path="/passwordRecovery/:id" name="passwordRecovery" element={<PasswordRecovery />} />
          <Route path="*" element={<PrivateRoute />}>
            <Route path="*" name="Home" element={<DefaultLayout />} />
          </Route>
        </Routes>
      </HashRouter>

      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

    </>

  )
}

export default App
